module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form form--inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [(_vm.mainQuestion) ? _c('h2', {
    class: ['h2', 'mt0', {
      mb2: !_vm.mainQuestion.subheading
    }],
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.mainQuestion.text))]) : _vm._e(), _vm._v(" "), (_vm.mainQuestion) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.mainQuestion.subheading))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.questions), function(question) {
    return _c('div', {
      key: question.id
    }, [(question.kind === 'radio' || question.kind === 'checkbox') ? _c('div', [(_vm.mainQuestion.multiple_questions) ? _c('label', {
      staticClass: "form-label"
    }, [_vm._v(_vm._s(question.text))]) : _vm._e(), _vm._v(" "), _vm._l((question.choices), function(choice, key) {
      return _c('div', {
        key: key,
        staticClass: "form-radio",
        on: {
          "change": function($event) {
            return _vm.handleSelect(choice, $event)
          },
          "click": function($event) {
            return _vm.unCheck(question)
          }
        }
      }, [_c('label', {
        staticClass: "form-label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.allAnswers[question.id]),
          expression: "allAnswers[question.id]"
        }],
        attrs: {
          "type": "radio",
          "name": question.id
        },
        domProps: {
          "value": choice.text,
          "checked": _vm._q(_vm.allAnswers[question.id], choice.text)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.allAnswers, question.id, choice.text)
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(choice.text))])])])
    }), _vm._v(" "), (question.placeholder) ? _c('span', {
      staticClass: "p form-fieldset__foot-note"
    }, [_vm._v(_vm._s(question.placeholder))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (question.kind === 'dropdown') ? _c('div', {
      staticClass: "form-fieldset"
    }, [(_vm.mainQuestion.multiple_questions) ? _c('label', {
      staticClass: "form-label",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(question.text))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-field"
    }, [_c('div', {
      staticClass: "form-wrap"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.allAnswers[question.id]),
        expression: "allAnswers[question.id]"
      }],
      staticClass: "form-select",
      attrs: {
        "name": question.id
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.allAnswers, question.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleSelect(question, $event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }), _vm._v(" "), _vm._l((question.choices), function(choice) {
      return _c('option', {
        key: choice.id,
        domProps: {
          "value": choice.text
        }
      }, [_vm._v(_vm._s(choice.text))])
    }), _vm._v("\\\n            ")], 2), _vm._v(" "), _c('span', {
      staticClass: "form-arrow"
    })])])]) : _vm._e(), _vm._v(" "), (question.kind === 'yes_no') ? _c('div', {
      staticClass: "form-field-button"
    }, [_c('module-button', {
      attrs: {
        "emit": true,
        "value": question.yes_button_text ? true : null,
        "button": "primary"
      },
      on: {
        "parentAction": _vm.handleBoolean
      }
    }, [_vm._v(_vm._s(question.yes_button_text ? question.yes_button_text : 'Yes'))]), _vm._v(" "), _c('module-button', {
      attrs: {
        "emit": true,
        "value": question.no_button_text ? false : null,
        "button": "primary"
      },
      on: {
        "parentAction": _vm.handleBoolean
      }
    }, [_vm._v(_vm._s(question.no_button_text ? question.no_button_text : 'No'))])], 1) : _vm._e(), _vm._v(" "), (question.kind === 'number') ? _c('div', [_c('div', {}, [_c('div', {
      staticClass: "form-wrap"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.allAnswers[question.id]),
        expression: "allAnswers[question.id]"
      }],
      staticClass: "form-select",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      attrs: {
        "name": question.id
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.allAnswers, question.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleSelect(question, $event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": ""
      },
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("0")]), _vm._v(" "), _vm._l((30), function(i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(i))])
    })], 2), _vm._v(" "), _c('span', {
      staticClass: "form-arrow"
    })])])]) : _vm._e(), _vm._v(" "), (question.kind === 'text') ? _c('div', [_c('module-fieldset', _vm._b({
      attrs: {
        "type": question.kind,
        "id": question.id,
        "label": question.text,
        "placeholder": question.placeholder,
        "required": question.is_required,
        "min": question.min_length,
        "max": question.max_length
      }
    }, 'module-fieldset', question, false))], 1) : _vm._e(), _vm._v(" "), (question.kind === 'regex') ? _c('div', [_c('module-fieldset', _vm._b({
      attrs: {
        "type": "text",
        "id": question.id,
        "label": question.text,
        "placeholder": question.placeholder,
        "required": question.is_required,
        "min": question.min_length,
        "max": question.max_length
      }
    }, 'module-fieldset', question, false))], 1) : _vm._e(), _vm._v(" "), (question.kind === 'text_box') ? _c('div', [_c('module-fieldset', _vm._b({
      attrs: {
        "type": "textarea",
        "id": question.id,
        "label": " ",
        "placeholder": question.placeholder,
        "value": ""
      }
    }, 'module-fieldset', question, false))], 1) : _vm._e()])
  }), _vm._v(" "), (!_vm.hideSubmitButton) ? _c('module-button', {
    attrs: {
      "disabled": _vm.disableSubmitButton || _vm.loading,
      "button": "primary",
      "loading": _vm.saving || _vm.loading
    }
  }, [_vm._v("Continue")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc515d48"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Questionnaire.vue
// module id = 459
// module chunks = 0